import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Backdrop,
  AppBar,
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Box,
  Checkbox,
  Snackbar,
  Alert,
  FormControlLabel,
  Stack,
  CircularProgress,
  IconButton,
  Typography,
} from "@mui/material";
import { Grid } from "@mui/material";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import PostAddIcon from "@mui/icons-material/PostAdd";
import axiosBaseURL from "../../../utilities/httpCommon";
import {
  inserttemplateIDinDoc,
  readTemplateID,
  readTemplateVersionID,
  GetDetailsofCC,
  readAgreemntID,
  DeleteTemplateverIDinDoc,
  readLockVersionID,
  readLockedID,
  GetLockdetails,
  readLockdetailsfromDoc,
} from "../../../utilities/Wordutil";
import SmartfieldDialog from "./SmartfieldDialog";
import OfficeAddinMessageBar from "./OfficeAddinMessageBar";
//import process = require("process");

/* global console window Office Word localStorage */

//axios.defaults.baseURL = process.env.REACT_APP_API_KEY;

const Newtemplate = (props: any) => {
  const [businesslist, setbusinesslist] = useState([]);
  const [agreementlist, setagreementlist] = useState([]);
  const [categorylist, setcategorylist] = useState([]);
  const [typelist, settypelist] = useState([]);
  const [checked, setChecked] = React.useState(false);
  const [checkedupdate, setcheckedupdate] = useState(false);
  const [popupopen, setpopupopen] = React.useState(false);
  //const [titlevalue, settitlevale] = React.useState("");
  const [btntitle, setbtntitle] = React.useState("");
  const [tabtitle, settabtitle] = React.useState("");
  const [tempplateid, settemplateid] = useState("");
  const [showUpdateCurver, setshowUpdateCurver] = useState(false);
  const [agreementid, setagreementid] = useState("");
  const [messagecaption, setmessagecaption] = useState("");
  const [savedisable, setsavedisable] = useState(false);
  const [smartlist, setsmartlist] = useState([]);
  const [mergefldinfo, setmergefldinfo] = useState("");
  const [tabvalue, settabValue] = React.useState("1");
  const [errMsgd, seterrMsgd] = useState("");

  const history = useHistory();

  const defFormValues = {
    templatename: "",
    businessobj: "",
    agreementtype: "",
    category: "",
    isactive: false,
    guidance: "",
    description: "",
    type: "",
    mergefields: "",
    Version_Number__c: null,
  };
  const defvervalues = {
    Name: "",
    Version_Number__c: null,
    Mergefields__c: "",
    Comments__c: "",
    Template__c: null,
  };

  const [templatevalues, settemplatevalues] = useState(defFormValues);
  const [tempVersionvalues, settempVersionvalues] = useState(defvervalues);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const errorDismissed = () => {
    seterrMsgd("");
  };

  const QueryData = async (soqlquery: string, childrelation: boolean) => {
    try {
      setLoading(true);
      console.log("New Update for AWS");
      const res = await axiosBaseURL
        .get("/sfserver/query?q=" + soqlquery, {
          withCredentials: true,
        })
        .catch((error) => {
          setLoading(false);
          if (error.response) {
            seterrMsgd(error.response.data);
          } else if (error.request) {
            seterrMsgd(error.request);
          } else {
            seterrMsgd(error.message);
          }
        });
      console.log(res.data);
      setLoading(false);
      if (res.data != null) {
        if (!childrelation) return res.data.records;
        else if (childrelation) return res.data;
      } else return null;
    } catch (err) {
      setLoading(false);
      return null;
    }
  };

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    settabValue(newValue);
  };

  const handleClosedlg = (dlgresult?: any) => {
    setOpen(false);
    if (dlgresult != null && dlgresult === "OK") {
      UpdateSFagreement().then(() => {
        console.log("Agreement updated");
      });
    }
  };

  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setpopupopen(false);
    history.push("/");
  };

  const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const handleUpdCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setcheckedupdate(event.target.checked);
  };

  function handleSubmit(event) {
    event.preventDefault();
    if (!props.Isupdate) {
      const templatedata = {
        Name: templatevalues.templatename,
        Business_Object__c: templatevalues.businessobj,
        Agreement_Type__c: templatevalues.agreementtype,
        Category__c: templatevalues.category,
        IsActive__c: checked,
        Guidance__c: templatevalues.guidance,
        Description__c: templatevalues.description,
        Type__c: templatevalues.type,
      };
      setLoading(true);
      axiosBaseURL
        .post("/sfserver/createtemplate", templatedata, {
          withCredentials: true,
        })
        .catch((error) => {
          setLoading(false);
          if (error.response) {
            console.log(error.response);
            seterrMsgd(error.response.data);
          } else if (error.request) {
            seterrMsgd(error.request);
          } else {
            seterrMsgd(error.message);
          }
        })
        .then(async (response) => {
          setLoading(false);
          setpopupopen(true);
          settemplatevalues(defFormValues);
          console.log(response);
          await inserttemplateIDinDoc(response.data);
        });
    } else {
      setLoading(true);
      ToAllowCheckInDoc().then((res) => {
        setLoading(false);
        console.log("tab value");
        console.log(tabvalue);
        if (res === "") {
          GetMergeFieldsfromDoc().then(async (res) => {
            if (res != null) {
              setagreementid("");
              setsmartlist([]);
              console.log("My merge fields...");
              console.log(res.allmergeinfo);
              setmergefldinfo(res.allmergeinfo);
              templatevalues.mergefields = res.allmergeinfo;
              getDocumentAsCompressed();
            }
          });
        } else {
          //console.log("Wrong User...");
          setmessagecaption("This document is locked by " + res);
          setpopupopen(true);
        }
      });
    }
  }

  const handleVerInputChange = (e) => {
    const { name, value } = e.target;
    settempVersionvalues({
      ...tempVersionvalues,
      [name]: value,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    settemplatevalues({
      ...templatevalues,
      [name]: value,
    });
  };

  const UpdateSFagreement = async () => {
    let reqdata = {};
    setLoading(true);
    smartlist.forEach((element) => {
      reqdata[element.name] = element.docvalue;
    });
    reqdata["Id"] = agreementid;
    await axiosBaseURL
      .post("/sfserver/updateagreement", reqdata, {
        withCredentials: true,
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          console.log(error.response);
          seterrMsgd(error.response.data);
        } else if (error.request) {
          seterrMsgd(error.request);
        } else {
          seterrMsgd(error.message);
        }
      });
    setLoading(false);
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);
      console.log("Loading checkin...");
      const res = await axiosBaseURL
        .get("/sfserver/getmetadata?object=Template__c", {
          withCredentials: true,
        })
        .catch((error) => {
          setLoading(false);
          if (error.response) {
            seterrMsgd(error.response.data);
          } else if (error.request) {
            seterrMsgd(error.request);
          } else {
            seterrMsgd(error.message);
          }
        });
      setIsLoading(false);
      if (res.data != null) {
        console.log(res.data.fields);
        res.data.fields.forEach((field) => {
          if (field.picklistValues.length > 0) {
            if (field.name == "Business_Object__c") {
              setbusinesslist(field.picklistValues);
            } else if (field.name == "Agreement_Type__c") {
              setagreementlist(field.picklistValues);
            } else if (field.name == "Category__c") {
              setcategorylist(field.picklistValues);
            } else if (field.name == "Type__c") {
              settypelist(field.picklistValues);
            }
          }
        });
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const ToAllowCheckInDoc = async () => {
    let IsRightAllow = "";
    let loginUsrid = localStorage.getItem("sfuserid");

    let checkreadonlydoc = await readLockdetailsfromDoc();
    if (checkreadonlydoc != null && checkreadonlydoc.readonly != "") {
      IsRightAllow = checkreadonlydoc.locked;
    }

    if (IsRightAllow === "") {
      let doctempId = await readLockedID();
      console.log("loginUsrid");
      console.log(doctempId);
      if (doctempId != null && doctempId != "" && loginUsrid != null) {
        let doclock = await GetLockdetails(doctempId);
        if (doclock != null && doclock.id != "NA") {
          if (doclock.id != loginUsrid) {
            IsRightAllow = doclock.name;
          }
        }
      }
    }

    //Check for Template version
    if (IsRightAllow === "" && tabvalue === "1") {
      let doctempId1 = await readTemplateID();
      if (doctempId1 != null && doctempId1 != "" && loginUsrid != null) {
        let doclock = await GetLockdetails(doctempId1);
        if (doclock != null && doclock.id != "NA") {
          if (doclock.id != loginUsrid) {
            IsRightAllow = doclock.name;
          }
        }
      }
    }
    //Ends here

    return IsRightAllow;
  };

  const LoadDatafromSF = async () => {
    setsavedisable(false);
    //settitlevale(props.Isupdate ? "Check-In template" : "Create template");
    setbtntitle(props.Isupdate ? "Check-In" : "Save");
    settabtitle(props.Isupdate ? "Template update" : "Template create");
    setmessagecaption(
      props.Isupdate ? "Template has been updated and check-in successfully" : "Template has been created successfully"
    );
    await fetchData();
    if (props.Isupdate) {
      try {
        setIsLoading(true);
        let strID = await readTemplateID();
        settemplateid(strID);
        let strVersionID = await readTemplateVersionID();
        console.log("Template version");
        console.log(strVersionID);
        if (strID == null || strID.length == 0) {
          setIsLoading(false);
          setpopupopen(true);
          setsavedisable(true);
          setmessagecaption("Plesae create a new template to check-in");
        }
        if (strVersionID != null && strVersionID.length > 0) {
          let objverlist = [];
          let result = await QueryData(
            "SELECT Id, Version_Number__c FROM Template_Version__c where Template__r.id='" + strID + "'",
            false
          );
          if (result != null && Array.isArray(result)) {
            var vernos = result;
            if (vernos.length > 0) {
              vernos.map((e) => {
                if (e.Version_Number__c != null) {
                  objverlist.push({ id: e.Id, version: e.Version_Number__c });
                }
              });
              objverlist.sort((a, b) => (a.version > b.version ? 1 : -1));
            }
            console.log("Versions.....");
            console.log(objverlist);
            if (objverlist.length > 0) {
              if (objverlist[objverlist.length - 1].id === strVersionID) {
                setshowUpdateCurver(true);
              }
            }
          }
        }
        if (strID != undefined) {
          const res = await axiosBaseURL
            .get("/sfserver/gettemplate?id=" + strID, {
              withCredentials: true,
            })
            .catch((error) => {
              setLoading(false);
              if (error.response) {
                console.log(error.response);
                seterrMsgd(error.response.data);
              } else if (error.request) {
                seterrMsgd(error.request);
              } else {
                seterrMsgd(error.message);
              }
            });
          if (res.data != null) {
            console.log("Loaded template details...");
            console.log(res.data);
            templatevalues.templatename = res.data.Name;
            templatevalues.businessobj = res.data.Business_Object__c;
            templatevalues.agreementtype = res.data.Agreement_Type__c;
            templatevalues.category = res.data.Category__c;
            templatevalues.isactive = res.data.IsActive__c;
            templatevalues.guidance = res.data.Guidance__c;
            templatevalues.description = res.data.Description__c;
            templatevalues.type = res.data.Type__c;
            setChecked(res.data.IsActive__c);
            // if (strVersionID != null) {
            //   setChecked(false);
            // }
            if (tabvalue === "1") {
              setChecked(true);
            } else {
              setChecked(false);
            }
          }
        }
        if (strVersionID != null && strVersionID.length > 0) {
          const res = await axiosBaseURL
            .get("/sfserver/gettemplateversion?id=" + strVersionID, {
              withCredentials: true,
            })
            .catch((error) => {
              DeleteTemplateverIDinDoc();
              setLoading(false);
              if (error.response) {
                seterrMsgd(error.response.data);
              } else if (error.request) {
                seterrMsgd(error.request);
              } else {
                seterrMsgd(error.message);
              }
            });
          try {
            if (res != null && res.data != null) {
              tempVersionvalues.Name = res.data.Name;
              tempVersionvalues.Comments__c = res.data.Comments__c;
            }
          } catch {
            console.log("error");
          }
        }
        setIsLoading(false);
      } catch (err) {
        console.log(err.message);
      }
    }
  };

  async function getDocumentAsCompressed() {
    setLoading(true);
    Office.context.document.getFileAsync(Office.FileType.Compressed, { sliceSize: 65536 /*64 KB*/ }, function (result) {
      if (result.status == Office.AsyncResultStatus.Succeeded) {
        var myFile = result.value;
        var sliceCount = myFile.sliceCount;
        var slicesReceived = 0,
          gotAllSlices = true,
          docdataSlices = [];
        getSliceAsync(myFile, 0, sliceCount, gotAllSlices, docdataSlices, slicesReceived);
      }
    });
  }

  function getSliceAsync(file, nextSlice, sliceCount, gotAllSlices, docdataSlices, slicesReceived) {
    var datafile;
    file.getSliceAsync(nextSlice, function (sliceResult) {
      if (sliceResult.status == "succeeded") {
        if (!gotAllSlices) {
          return;
        }
        docdataSlices[sliceResult.value.index] = sliceResult.value.data;
        if (++slicesReceived == sliceCount) {
          file.closeAsync();
          onGotAllSlices(docdataSlices);
        } else {
          getSliceAsync(file, ++nextSlice, sliceCount, gotAllSlices, docdataSlices, slicesReceived);
        }
      } else {
        gotAllSlices = false;
        setLoading(false);
        file.closeAsync();
      }
    });
    return datafile;
  }

  async function GetFileurl() {
    return new Promise((resolve) => {
      Office.context.document.getFilePropertiesAsync(null, (res) => {
        if (res && res.value && res.value.url) {
          let name = res.value.url;
          resolve(name);
        }
        resolve("");
      });
    });
  }

  function removeDuplicates(array, key) {
    let lookup = {};
    array.forEach((element) => {
      lookup[element[key]] = element;
    });
    return Object.keys(lookup).map((key) => lookup[key]);
  }

  async function onGotAllSlices(docdataSlices) {
    var docdata = [];
    for (var i = 0; i < docdataSlices.length; i++) {
      docdata = docdata.concat(docdataSlices[i]);
    }
    var fileContent = "";
    for (var j = 0; j < docdata.length; j++) {
      fileContent += String.fromCharCode(docdata[j]);
    }
    var base64data = window.btoa(fileContent);

    console.log("Merge Result");
    console.log(mergefldinfo);
    console.log("Template values...");
    console.log(templatevalues);

    var fileurl = await GetFileurl();
    var filename = fileurl.toString().split("\\")[fileurl.toString().split("\\").length - 1];
    var versionno = 1;
    let versionslist = [];
    let result = await QueryData(
      "SELECT Version_Number__c FROM Template_Version__c where Template__r.id='" + tempplateid + "'",
      false
    );
    if (result != null && Array.isArray(result)) {
      var vernos = result;
      if (vernos.length > 0) {
        vernos.map((e) => {
          if (e.Version_Number__c != null) {
            versionslist.push(e.Version_Number__c);
          }
        });
      }
    }
    result = await QueryData("SELECT Version_Number__c FROM Template__c where Id='" + tempplateid + "'", false);
    if (result != null && Array.isArray(result)) {
      vernos = result;
      if (vernos[0].Version_Number__c != null) {
        versionslist.push(vernos[0].Version_Number__c);
      }
    }
    if (versionslist.length > 0) {
      versionslist.sort((a, b) => (a > b ? 1 : -1));
      versionno = versionslist[versionslist.length - 1] + 1;
    }
    const templatedata = {
      Name: templatevalues.templatename,
      Business_Object__c: templatevalues.businessobj,
      Agreement_Type__c: templatevalues.agreementtype,
      Category__c: templatevalues.category,
      IsActive__c: checked,
      Guidance__c: templatevalues.guidance,
      Description__c: templatevalues.description,
      Type__c: templatevalues.type,
      Mergefields__c: templatevalues.mergefields,
      Version_Number__c: null,
    };
    const newcontentver = {
      ContentLocation: "S",
      PathOnClient: fileurl,
      Title: filename,
      VersionData: base64data,
    };
    var tempVersionid = "";
    let locktemplateverId = await readTemplateVersionID();
    var tmplockversionid = await readLockVersionID();
    var lockversionid = null;
    var doclock = await QueryData(
      "SELECT Id, Locked_By__c,  Locked_By__r.Name, Type__c, Content_Version_Id__c, IsLocked__c FROM Document_Lock__c where Content_Version_Id__c = '" +
        tmplockversionid +
        "'",
      false
    );
    if (doclock != null && Array.isArray(doclock) && doclock.length > 0) {
      lockversionid = doclock[0].Id;
    }
    if (templatedata.IsActive__c === false) {
      lockversionid = null;
    }
    if (checkedupdate) {
      tempVersionid = await readTemplateVersionID();
    } else {
      tempVersionid = "";
    }
    var templateversion = null;
    if (templatedata.IsActive__c === false) {
      templateversion = {
        Name: tempVersionvalues.Name,
        Version_Number__c: versionno,
        Mergefields__c: templatevalues.mergefields,
        Comments__c: tempVersionvalues.Comments__c,
        Template__c: tempplateid,
      };
    } else {
      templatedata.Version_Number__c = versionno;
      result = await QueryData(
        "SELECT Id, Description__c, Mergefields__c, Version_Number__c, Name FROM Template__c where Id='" +
          tempplateid +
          "'",
        false
      );
      if (result != null && Array.isArray(result) && result.length > 0) {
        var temprecd = result[0];
        if (temprecd.Version_Number__c != null) {
          templateversion = {
            Name: temprecd.Name,
            Version_Number__c: temprecd.Version_Number__c,
            Mergefields__c: temprecd.Mergefields__c,
            Comments__c: temprecd.Description__c,
            Template__c: tempplateid,
          };
        }
      }
    }
    setLoading(true);
    const res = await axiosBaseURL
      .post(
        "/sfserver/uploadtemplate",
        {
          templateid: tempplateid,
          templateobj: templatedata,
          contentversion: newcontentver,
          templatever: templateversion,
          updversionid: tempVersionid,
          lockedid: lockversionid,
          lockversionid: locktemplateverId,
        },
        {
          withCredentials: true,
        }
      )
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          seterrMsgd(error.response.data);
        } else if (error.request) {
          seterrMsgd(error.request);
        } else {
          seterrMsgd(error.message);
        }
      });
    console.log(res);
    if (res != null && res.data.status == "Success") {
      if (res.data.versionid != null) {
        await Word.run(async function (context) {
          context.document.properties.customProperties.add("Template Ver", res.data.versionid);
          await context.sync();
        });
      }
      setpopupopen(true);
    }
    setLoading(false);
  }

  async function GetMergeFieldsfromDoc() {
    setLoading(true);
    let flds = [];
    let smartflds = [];
    let mergetables = [];
    let mainobj = "";
    let allobj = "";
    let regex = /\(([^)]+)\)/g;
    let strID = "";
    await Word.run(async (context) => {
      strID = await readAgreemntID();
      let contentctrls = context.document.contentControls;
      contentctrls.load("items");
      await context.sync();
      for (var i = 0; i < contentctrls.items.length; i++) {
        contentctrls.items[i].load(
          "appearance," +
            "cannotDelete," +
            "cannotEdit," +
            "color," +
            "id," +
            "placeHolderText," +
            "removeWhenEdited," +
            "title," +
            "text," +
            "type," +
            "style," +
            "tag," +
            "font/size," +
            "font/name," +
            "font/color," +
            "parentContentControlOrNullObject"
        );
        let strtitle = contentctrls.items[i].title;
        let strId = contentctrls.items[i].id;
        if (strtitle === "Fields" || strtitle === "Clauses") {
          let details = await GetDetailsofCC(strId);
          if (strtitle === "Fields") {
            if (!details.istable) {
              flds.push({ name: details.name });
              if (details.smartfield != null && details.smartfield.toLowerCase() === "yes") {
                smartflds.push({ name: details.name, docvalue: contentctrls.items[i].text, sfvalue: "" });
              }
            }
          }
          if (details.all != null || details.all != undefined) {
            if (regex.test(details.all) && !details.istable) {
              let matches = details.all.match(regex);
              for (let mt = 0; mt < matches.length; mt++) {
                flds.push({ name: matches[mt].split(" ")[0].replace("(", "") });
              }
            }
          }
        }
      }
      //tables information
      const tblcctrls = [];
      for (i = 0; i < contentctrls.items.length; i++) {
        contentctrls.items[i].load(
          "appearance," +
            "cannotDelete," +
            "cannotEdit," +
            "color," +
            "id," +
            "placeHolderText," +
            "removeWhenEdited," +
            "title," +
            "text," +
            "type," +
            "style," +
            "tag," +
            "font/size," +
            "font/name," +
            "font/color," +
            "parentContentControlOrNullObject"
        );
        let strtitle = contentctrls.items[i].title;
        if (strtitle === "Repeat") {
          let strId = contentctrls.items[i].id;
          let details = await GetDetailsofCC(strId);
          if (details.all != null || details.all != undefined) {
            allobj = details.name;
            if (regex.test(details.all)) {
              let matches = details.all.match(regex);
              for (let mt = 0; mt < matches.length; mt++) {
                flds.push({ name: matches[mt].split(" ")[0].replace("(", "") });
              }
            }
          }
          contentctrls.items[i].load(
            "contentControls,contentControls/items,contentControls/items/title,contentControls/items/id"
          );
          console.log("table object parent");
          console.log(allobj);
          console.log("********************");
          tblcctrls.push({ id: allobj, controls: contentctrls.items[i], parentid: strId, tableid: strId });
        }
      }
      await context.sync();
      for (i = 0; i < tblcctrls.length; i++) {
        let sbtblflds = [];
        allobj = tblcctrls[i].id;
        for (var k = 0; k < tblcctrls[i].controls.contentControls.items.length; k++) {
          let strId = tblcctrls[i].controls.contentControls.items[k].id;
          let details = await GetDetailsofCC(strId);
          sbtblflds.push({ name: details.name });
          console.log("Condition in Rows");
          console.log(details.all);
          if (details.all != null || details.all != undefined) {
            if (regex.test(details.all) && details.istable) {
              let matches = details.all.match(regex);
              for (let mt = 0; mt < matches.length; mt++) {
                sbtblflds.push({ name: matches[mt].split(" ")[0].replace("(", "") });
              }
            }
          }
          //Check Row Conditions
          if (k == 0) {
            details = await GetDetailsofCC(tblcctrls[i].parentid, true);
            if (details.all != null || details.all != undefined) {
              if (regex.test(details.all)) {
                let matches = details.all.match(regex);
                for (let mt = 0; mt < matches.length; mt++) {
                  sbtblflds.push({ name: matches[mt].split(" ")[0].replace("(", "") });
                }
              }
            }
          }
          //Ends here
        }
        let parentfld = {
          referenceTo: {
            name: "",
            referenceTo: null,
          },
        };
        mainobj = allobj.split(".")[allobj.split(".").length - 1];
        let objs = allobj.split(".");
        for (var h = 0; h < objs.length - 1; h++) {
          if (h == 0) {
            parentfld.referenceTo.name = objs[h];
          } else if (h == 1) {
            parentfld.referenceTo.referenceTo = { name: objs[h], referenceTo: null };
          } else if (h == 2) {
            parentfld.referenceTo.referenceTo["referenceTo"] = { name: objs[h], referenceTo: null };
          }
        }
        //Remove duplicates
        let uniquetblflds = [];
        uniquetblflds = removeDuplicatesintflds(sbtblflds.reverse());
        if (uniquetblflds.length > 0) {
          uniquetblflds.reverse();
        }
        // const uniquetblflds = sbtblflds.filter((element) => {
        //   const isDuplicate = untblflds.includes(element.name);
        //   if (!isDuplicate) {
        //     untblflds.push(element.name);
        //     return true;
        //   }
        //   return false;
        // });

        //Ends here
        //mergetables.push({ objectName: mainobj, tableFields: sbtblflds, parentrelation: parentfld });
        mergetables.push({
          objectName: mainobj,
          tableFields: uniquetblflds,
          parentrelation: parentfld,
          tid: tblcctrls[i].tableid,
        });
      }
    });
    flds = removeDuplicates(flds, "name");
    var mergeJSON = {
      mergefields: {
        objectName: "Agreement__c",
        fields: flds,
      },
      mergetables: mergetables,
    };
    const filteredflds = JSON.stringify(mergeJSON);
    setLoading(false);
    console.log(filteredflds);
    return { allmergeinfo: filteredflds, smartfields: smartflds, id: strID };
  }

  useEffect(() => {
    LoadDatafromSF();
  }, []);

  function removeDuplicatesintflds(arr) {
    let uniqueArr = [];
    let seen = new Set();
    for (let item of arr) {
      if (!seen.has(item.name)) {
        seen.add(item.name);
        uniqueArr.push(item);
      }
    }
    return uniqueArr;
  }

  useEffect(() => {
    if (tabvalue === "1") {
      setChecked(true);
    } else if (tabvalue === "2") {
      setChecked(false);
    }
  }, [tabvalue]);

  return (
    <Box sx={{ p: 2 }}>
      {errMsgd.length > 0 ? <OfficeAddinMessageBar onDismiss={errorDismissed} message={errMsgd + " "} /> : null}
      {isLoading ? (
        <div>
          <Typography>Loading ...</Typography>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <Snackbar open={popupopen} onClose={handleClose}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    handleClose();
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="success"
              sx={{ width: "100%" }}
            >
              {messagecaption}
            </Alert>
          </Snackbar>
          <TabContext value={tabvalue}>
            <TabList
              onChange={handleTabChange}
              aria-label="Properties"
              variant="standard"
              sx={{ minHeight: "36px", height: "36px" }}
            >
              <Tab
                label={tabtitle}
                icon={<SaveIcon sx={{ width: 16, height: 16 }} />}
                iconPosition="start"
                value="1"
                sx={{
                  minHeight: "36px",
                  height: "36px",
                  padding: 0.75,
                  textTransform: "none",
                  fontFamily: "Arial",
                  fontWeight: "semibold",
                }}
              />
              {props.Isupdate && (
                <Tab
                  label="Template Version"
                  value="2"
                  icon={<PostAddIcon sx={{ width: 16, height: 16 }} />}
                  iconPosition="start"
                  sx={{
                    minHeight: "36px",
                    height: "36px",
                    padding: 0.75,
                    textTransform: "none",
                    fontFamily: "Arial",
                    fontWeight: "semibold",
                  }}
                />
              )}
            </TabList>
            <TabPanel value="1" sx={{ padding: 0 }}>
              <Grid container>
                <Grid item xs={12} marginTop={2.5}>
                  <FormControl fullWidth size="small" sx={{ marginTop: 0 }}>
                    <TextField
                      name="templatename"
                      label="Template name"
                      size="small"
                      value={templatevalues.templatename}
                      variant="outlined"
                      onChange={handleInputChange}
                      error={!templatevalues.templatename}
                      required
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} marginTop={2.5}>
                  <FormControl fullWidth size="small" error={!templatevalues.businessobj}>
                    <InputLabel id="businessobj">Select Business Object</InputLabel>
                    {businesslist.length > 0 && (
                      <Select
                        labelId="businessobj"
                        label="Select Business Object"
                        size="small"
                        name="businessobj"
                        disabled={props.Isupdate}
                        value={templatevalues.businessobj}
                        variant="outlined"
                        onChange={handleInputChange}
                        error={!templatevalues.businessobj}
                        required
                      >
                        {businesslist.map((picklst) => (
                          <MenuItem key={picklst.label} value={picklst.value}>
                            {picklst.value}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} marginTop={2.5}>
                  <FormControl fullWidth size="small" error={!templatevalues.agreementtype}>
                    <InputLabel id="agreementtype">Select Agreement type</InputLabel>
                    {agreementlist.length > 0 && (
                      <Select
                        multiline
                        labelId="agreementtype"
                        name="agreementtype"
                        size="small"
                        label="Select Agreement type"
                        value={templatevalues.agreementtype}
                        variant="outlined"
                        onChange={handleInputChange}
                        error={!templatevalues.agreementtype}
                        required
                      >
                        {agreementlist.map((picklst) => (
                          <MenuItem key={picklst.label} value={picklst.value}>
                            {picklst.value}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} marginTop={2.5}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="category">Select Category</InputLabel>
                    {categorylist.length > 0 && (
                      <Select
                        variant="outlined"
                        labelId="category"
                        name="category"
                        size="small"
                        value={templatevalues.category}
                        label="Select Category"
                        onChange={handleInputChange}
                      >
                        {categorylist.map((picklst) => (
                          <MenuItem key={picklst.label} value={picklst.value}>
                            {picklst.value}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} marginTop={2.5}>
                  <FormControl fullWidth size="small">
                    <TextField
                      label="Guidance"
                      name="guidance"
                      size="small"
                      id="filled-size-small"
                      value={templatevalues.guidance}
                      variant="outlined"
                      onChange={handleInputChange}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} marginTop={2.5}>
                  <FormControl fullWidth size="small">
                    <TextField
                      label="Description"
                      name="description"
                      size="small"
                      id="filled-size-small"
                      value={templatevalues.description}
                      variant="outlined"
                      onChange={handleInputChange}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} marginTop={2.5} marginBottom={0}>
                  <FormControl fullWidth size="small" sx={{ marginBottom: 2.15 }} error={!templatevalues.type}>
                    <InputLabel id="type">Select Type</InputLabel>
                    {typelist.length > 0 && (
                      <Select
                        labelId="type"
                        name="type"
                        label="Select Type"
                        size="small"
                        value={templatevalues.type}
                        placeholder="Select Type"
                        onChange={handleInputChange}
                        error={!templatevalues.type}
                        required
                      >
                        {typelist.map((picklst) => (
                          <MenuItem key={picklst.label} value={picklst.value}>
                            {picklst.value}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} marginTop={0} marginBottom={1} padding={0}>
                  <FormControlLabel
                    disabled={props.Isupdate ? true : false}
                    control={<Checkbox checked={checked} onChange={handleCheckChange} />}
                    label="Is Active"
                  />
                </Grid>
                <SmartfieldDialog open={open} onClose={handleClosedlg} autolist={smartlist} />
              </Grid>
            </TabPanel>
            <TabPanel value="2" sx={{ padding: 0 }}>
              <Grid container>
                <Grid item xs={12} marginTop={2.5}>
                  <FormControl fullWidth size="small" sx={{ marginTop: 0 }}>
                    <TextField
                      name="Name"
                      label="Template name"
                      size="small"
                      value={tempVersionvalues.Name}
                      variant="outlined"
                      onChange={handleVerInputChange}
                      error={!tempVersionvalues.Name}
                      required
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} marginTop={2.5}>
                  <FormControl fullWidth size="small">
                    <TextField
                      label="Comments"
                      name="Comments__c"
                      size="small"
                      id="filled-size-small"
                      value={tempVersionvalues.Comments__c}
                      variant="outlined"
                      onChange={handleVerInputChange}
                    />
                  </FormControl>
                </Grid>
                {showUpdateCurver && (
                  <Grid item xs={12} marginTop={0} marginBottom={1} padding={0}>
                    <FormControlLabel
                      control={<Checkbox checked={checkedupdate} onChange={handleUpdCheckChange} />}
                      label="Update Current Version"
                    />
                  </Grid>
                )}
              </Grid>
            </TabPanel>
          </TabContext>
          <AppBar position="fixed" sx={{ top: "auto", bottom: 0 }}>
            <Stack direction="row" spacing={2}>
              <Button
                variant="contained"
                disabled={savedisable}
                size="small"
                type="submit"
                sx={{ width: "100%", bgcolor: "#1C39BB" }}
              >
                <Typography>{btntitle}</Typography>
              </Button>
            </Stack>
          </AppBar>
        </form>
      )}
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default Newtemplate;
